<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>기부처 관리</strong></div>
			<h2 class="h_sub">기부처 관리</h2>
		</div>

    <DonationCategoryManageListForm/>
  </div>
</template>

<script>
import DonationCategoryManageListForm from '@/components/admin/etc/DonationCategoryManageListForm.vue';

export default {
  components: {
    DonationCategoryManageListForm
  }
}
</script>
<style lang="">

</style>